import React from 'react';
import {
  DashboardMetricMetadata,
  SalesManagerDashboardStats,
} from '@dreamai/types';

import './manager-stats.scss';

interface ManagerStatsProps {
  stats: Record<string, any>;
  displayMetadata: Record<string, DashboardMetricMetadata>;
}

const ManagerStats: React.FC<ManagerStatsProps> = ({
  stats,
  displayMetadata,
}) => {
  // Sort metrics by order
  const sortedMetrics = Object.entries(displayMetadata).sort(
    ([, a], [, b]) => a.order - b.order,
  );

  const formatValue = (
    key: string,
    value: number,
    metadata: DashboardMetricMetadata,
  ) => {
    switch (metadata.format) {
      case 'currency':
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: metadata.currency || 'USD',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(value);
      case 'percentage':
        return `${value.toFixed(1)}%`;
      case 'number-with-suffix':
        return `${value.toLocaleString()} ${metadata.suffix || ''}`;
      case 'number':
      default:
        return value.toLocaleString();
    }
  };

  return (
    <div className='manager-stats'>
      {sortedMetrics.map(([key, metadata]) => {
        const value = stats[key as keyof SalesManagerDashboardStats] as number;
        return (
          <div key={key} className='stat-item'>
            <div className='stat-label'>{metadata.label}</div>
            <div className='stat-value'>
              {formatValue(key, value, metadata)}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ManagerStats;
